import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Bell: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z"
      fill="#4B4D4F"
    />
    <path
      d="M19 17H18V10C18 7.21 16.09 4.86 13.5 4.2V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V4.2C7.91 4.86 6 7.21 6 10V17H5C4.45 17 4 17.45 4 18C4 18.55 4.45 19 5 19H19C19.55 19 20 18.55 20 18C20 17.45 19.55 17 19 17ZM14 13H13V14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14V13H10C9.45 13 9 12.55 9 12C9 11.45 9.45 11 10 11H11V10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10V11H14C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13Z"
      fill="#4B4D4F"
    />
  </Box>
)
export default Bell
